import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import DatePickerField from "../../component/InputFieldLayout/datePicker";
import NumberField from "../../component/InputFieldLayout/numberField";
import {
  getRecipientMinistryStateAction,
  getAllStatesAction,
  activeReport,
  getAllMoms
} from "../../actions/mis.action";
import { MULTI_STATE_PROJECT, SELECT_MONITORING_OPTION } from "../../constant";
import {
  fetchProjectReport,
  fetchIssueSubCategories,
  getMisListAction,
  getMisReportListAction
} from "../../actions/mis.action";
import { constant, parseInt, uniqBy } from "lodash";
import { getLocalstorage, setLocalstorage } from "../../helper";
import Select from "react-select";
import { components } from "react-select";
import { replaceCharacterWith } from "../../../src/helper";
import { getMeetingTypesDetails } from "../../actions/projectDetail.action";
import {
  fetchSelectedStateValue,
  fetchStateProjectReport2,
  fetchSelectedMonitoringValue,
  fetchMonitoringValue,
  fetchMeetingValue,
  getIssueList,
  getIssuesTimelineLapsed,
  getIssuesPending,
  getIssuesResolved,
  getIssuesReviewed,
  getmeetingsCount,
  getmeetingsDateAction
} from "../../actions/mis.action";

import { eachDayOfInterval } from "date-fns/esm";
import CustomDropdown from "../reusableComponent/Dropdown/CustomDropdown";

//import { fetchProjectReport,getMisListAction,getMisReportListAction } from "../../actions/mis.action";

class StateSummaryFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //formData: this._getInitForm(),
      openModal: true,
      stateList: [],
      sponsoringMinistryList: [],
      inceptionDate: false,
      filtersList: [],
      compilanceFilterList: [],
      appliedFilter: getLocalstorage("projectSummaryFilters") || [],
      previousFilterCount: 0,
      currentFilterCount: 0,
      selectedStatevalue: null,
      selectedMonitoringvalue: null,
      selectedMeetingvalue: null,
      meetingList: [],
      bubbleFilterCount: 0
    };
  }

  async componentDidMount() {
    const {
      activeReport,
      getRecipientMinistryStateAction,
      getAllStatesAction,
      getMeetingTypesDetails,
      selectedState,
      getAllMoms,
      getIssueList
    } = this.props;

    getIssueList({ category: ["STATE"] });
    getAllMoms();
    await getAllStatesAction().then(resp => {
      if (resp) {
        this.setState({
          stateList: resp.data.data
        });
      }
    });

    await getMeetingTypesDetails().then(resp => {
      if (resp) {
        this.setState({
          meetingList: resp
        });
      }
    });

    //Set the State & monitoring flag values if different

    if (activeReport === "STATE_SUMMARY") {
      const stateTempArray = JSON.parse(localStorage.getItem("filtersList"));

      if (
        stateTempArray &&
        stateTempArray.length > 0 &&
        stateTempArray &&
        stateTempArray[0]["value"] &&
        stateTempArray[0]["optionName"] === "SelectState"
      ) {
        this.setState({
          selectedStatevalue: stateTempArray[0]["value"] || null
        });
      } else {
        this.setState({ selectedStatevalue: null });
      }
    } else {
      const stateTempArray1 = JSON.parse(
        localStorage.getItem("compilanceFilterList")
      );

      if (
        stateTempArray1 &&
        stateTempArray1.length > 0 &&
        stateTempArray1 &&
        stateTempArray1[0]["value"] &&
        stateTempArray1[0]["optionName"] === "SelectState"
      ) {
        this.setState({
          selectedStatevalue: stateTempArray1[0]["value"] || null
        });
      } else {
        this.setState({ selectedStatevalue: null });
      }
    }

    const monitoringTempArray = JSON.parse(localStorage.getItem("monitoring"));

    if (monitoringTempArray && monitoringTempArray["value"]) {
      this.setState({
        selectedMonitoringvalue: monitoringTempArray["value"] || null
      });
    } else {
      this.setState({ selectedMonitoringvalue: null });
    }

    const meetingTypeTempArray = JSON.parse(
      localStorage.getItem("meetingType")
    );

    if (meetingTypeTempArray && meetingTypeTempArray["value"]) {
      this.setState({
        selectedMeetingvalue: meetingTypeTempArray["value"] || null
      });
    } else {
      this.setState({ selectedMeetingvalue: null });
    }
  }

  stateValue = () => {
    const arrayString = localStorage.getItem("filtersList");

    const myArray = JSON.parse(arrayString);
    if (myArray)
      if (myArray && myArray.length > 0) {
        // this .setState({selectedStatevalue:myArray['value'] || null});
      } else {
        //  this .setState({selectedStatevalue: null})
      }
    //this.setState({bubbleFilterCount : this.props.chipResetCount})
  };

  render() {
    const { states, selectedMeetingvalue } = this.state;

    // this.stateValue()
    const {
      activeReport,
      selectedState,
      agendaList,
      selectedMonitoring,
      selectMeetingType,
      chipResetCount
    } = this.props;

    if (agendaList.data === null || agendaList.data === undefined) {
    } else {
    }

    const stateOptions = [];
    if (activeReport === "STATE_SUMMARY") {
      // stateOptions.push({
      //   name: "states",
      //   label: "Select State/UT",
      //   value: "",
      //   optionName: "states"
      // })
      this.state.stateList.map(states => {
        stateOptions.push({
          name: "states",
          label: states.name,
          value: states.id,
          optionName: "states"
        });
        return stateOptions;
      });
    } else {
      if (agendaList.data === null || agendaList.data === undefined) {
      } else {
        // stateOptions.push({
        //   name: "states",
        //   label: "Select State/UT",
        //   value: "",
        //   optionName: "states"
        // })

        agendaList.data.map(states => {
          stateOptions.push({
            name: "states",
            label: states.name,
            value: states.id,
            optionName: "SelectState"
          });

          return stateOptions;
        });
      }
    }

    const meetingOptions = [];
    // meetingOptions.push({
    //   name: "meeting",
    //   label: "Select Meeting Type",
    //   value: "",
    //   optionName: "meeting"
    // });

    this.state.meetingList.map(meeting => {
      meetingOptions.push({
        name: "meeting",
        label: meeting,
        value: meeting,
        optionName: "meeting"
      });
      return meetingOptions;
    });

    const monitoringList = [
      "MARCH 24",
      "PRAGATI",
      "NIP",
      "PM FOUNDATION STONE",
      "PM GATISHAKTI",
      "PLI",
      "PORT CONNECTIVITY",
      "COAL EVACUATION",
      "eSamikSha"
    ];
    const monitoringOptions = [];
    monitoringOptions.push({
      name: "meeting",
      label: "Select Monitoring Flag",
      value: "",
      optionName: "meeting"
    });
    monitoringList.map(option => {
      monitoringOptions.push({
        name: "monitoring",
        label: option,
        value: option,
        optionName: "monitoring"
      });
      return monitoringOptions;
    });

    const onSelectMeetingType = async e => {
      const {
        getMisListAction,
        getMisReportListAction,
        fetchMeetingValue,
        getIssuesTimelineLapsed,
        getIssuesPending,
        getIssuesResolved,
        getIssuesReviewed,
        getmeetingsCount,
        getmeetingsDateAction
      } = this.props;

      let SelectedValue = e.target.value;

      this.setState({ selectedMeetingvalue: e.target.value });
      const matchingState = meetingOptions.find(function(state) {
        return state.value == SelectedValue;
      });
      const selectedLabel = matchingState ? matchingState.label : undefined;

      let selectedValue = {
        name: selectedLabel ? selectedLabel : "",
        label: selectedLabel ? selectedLabel : "",
        value: SelectedValue ? SelectedValue : "",
        optionName: "Meeting"
      };
      let selectedState1;
      if (
        JSON.parse(localStorage.getItem("selectedState")) == null ||
        JSON.parse(localStorage.getItem("selectedState")) == undefined
      ) {
        selectedState1 = {
          name: "",
          label: "Select State/ut",
          value: "",
          optionName: "SelectState"
        };
      } else {
        selectedState1 = JSON.parse(localStorage.getItem("selectedState"));
      }
      if (selectedValue !== null) {
        const updatedArray = [];
        if (
          selectedValue.value !== null &&
          selectedValue.value !== "" &&
          selectedValue.value !== undefined
        )
          updatedArray.push(selectedValue);

        if (
          selectedState1.value !== null &&
          selectedState1.value !== "" &&
          selectedState1.value !== undefined
        ) {
          updatedArray.push(selectedState1);
        }

        localStorage.setItem(
          "compilanceFilterList",
          JSON.stringify(updatedArray)
        );
      }

      fetchMeetingValue(selectedValue);
      localStorage.setItem("meetingType", JSON.stringify(selectedValue));
      this.props.onstateValueChange("0");
      localStorage.setItem("misPageChanged", true);

      fetch(getMisListAction(selectedState, selectedValue, 0))
        .then(response => response.json())
        .then(data => {
          // Handle the fetched data, e.g., update component state
          // this.setState({ data });
        })
        .catch(error => {
          // Handle errors
        });

      fetch(getIssuesTimelineLapsed(selectedState, selectedValue, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getIssuesPending(selectedState, selectedValue, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getIssuesResolved(selectedState, selectedValue, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getIssuesReviewed(selectedState, selectedValue, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getmeetingsCount(selectedState, selectedValue, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getmeetingsDateAction(selectedState, selectedValue, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
    };

    const onSourceAutoSuggestChange = async e => {
      let SelectedValue = e.target.value;

      this.setState({ selectedStatevalue: e.target.value });
      const matchingState = stateOptions.find(function(state) {
        return state.value == SelectedValue;
      });
      const selectedLabel = matchingState ? matchingState.label : undefined;

      const {
        getMisListAction,
        fetchSelectedStateValue,
        fetchStateProjectReport2,
        getIssuesTimelineLapsed,
        getIssuesPending,
        getIssuesResolved,
        getIssuesReviewed,
        getmeetingsDateAction,
        getmeetingsCount,
        selectMeetingType
      } = this.props;

      let selectedStatevalue1 = {
        name: selectedLabel ? selectedLabel : "",
        label: selectedLabel ? selectedLabel : "",
        value: SelectedValue ? SelectedValue : "",
        optionName: "SelectState"
      };
      localStorage.setItem(
        "selectedState",
        JSON.stringify(selectedStatevalue1)
      );

      let selectedMonitoring1;
      if (
        JSON.parse(localStorage.getItem("monitoring")) == null ||
        JSON.parse(localStorage.getItem("monitoring")) == undefined
      ) {
        selectedMonitoring1 = {
          name: "",
          label: "Select Monitoring Flag",
          value: " ",
          optionName: "Select Monitoring FlaG"
        };
      } else {
        selectedMonitoring1 = JSON.parse(localStorage.getItem("monitoring"));
      }

      let selectedMeetingType1;
      if (
        JSON.parse(localStorage.getItem("meetingType")) == null ||
        JSON.parse(localStorage.getItem("meetingType")) == undefined
      ) {
        selectedMeetingType1 = {
          name: "",
          label: "Select Meeting Type",
          value: " ",
          optionName: "Select Meeting Type"
        };
      } else {
        selectedMeetingType1 = JSON.parse(localStorage.getItem("meetingType"));
      }

      if (selectedStatevalue1 !== null) {
        const updatedArray = [];
        if (
          selectedStatevalue1.value !== null &&
          selectedStatevalue1.value !== " " &&
          selectedStatevalue1.value !== undefined
        )
          updatedArray.push(selectedStatevalue1);

        if (
          selectedMonitoring1.value !== null &&
          selectedMonitoring1.value !== " " &&
          selectedMonitoring1.value !== undefined
        ) {
          updatedArray.push(selectedMonitoring1);
        }

        localStorage.setItem("filtersList", JSON.stringify(updatedArray));
      }

      if (activeReport === "STATE_SUMMARY") {
        fetchSelectedStateValue(selectedStatevalue1);
        //updateSelectedItems()
        fetch(
          fetchStateProjectReport2(selectedStatevalue1, selectedMonitoring1, 0)
        )
          .then(response => response.json())
          .then(data => {})
          .catch(error => {});
      } else {
        //localStorage.setItem('misPageChanged', true);
        fetchSelectedStateValue(selectedStatevalue1);
        this.props.onstateValueChange("0");

        if (selectedStatevalue1 !== null) {
          const updatedArray = [];
          if (
            selectedStatevalue1.value !== null &&
            selectedStatevalue1.value !== " " &&
            selectedStatevalue1.value !== undefined
          )
            updatedArray.push(selectedStatevalue1);

          if (
            selectedMeetingType1.value !== null &&
            selectedMeetingType1.value !== " " &&
            selectedMeetingType1.value !== undefined
          ) {
            updatedArray.push(selectedMeetingType1);
          }

          localStorage.setItem(
            "compilanceFilterList",
            JSON.stringify(updatedArray)
          );
        }
        fetch(getmeetingsDateAction(selectedStatevalue1, selectMeetingType, 0))
          .then(response => response.json())
          .then(data => {})
          .catch(error => {});

        fetch(getmeetingsCount(selectedStatevalue1, selectMeetingType, 0))
          .then(response => response.json())
          .then(data => {})
          .catch(error => {});

        fetch(
          getIssuesTimelineLapsed(selectedStatevalue1, selectMeetingType, 0)
        )
          .then(response => response.json())
          .then(data => {})
          .catch(error => {});
        fetch(getIssuesPending(selectedStatevalue1, selectMeetingType, 0))
          .then(response => response.json())
          .then(data => {})
          .catch(error => {});
        fetch(getIssuesResolved(selectedStatevalue1, selectMeetingType, 0))
          .then(response => response.json())
          .then(data => {})
          .catch(error => {});

        fetch(getIssuesReviewed(selectedStatevalue1, selectMeetingType, 0))
          .then(response => response.json())
          .then(data => {})
          .catch(error => {});

        fetch(getMisListAction(selectedStatevalue1, selectMeetingType, 0))
          .then(response => response.json())
          .then(data => {})
          .catch(error => {
            // Handle errors
          });
      }
    };

    const onSelectofMonitoring = e => {
      const {
        fetchStateProjectReport2,
        selectedState,
        fetchMonitoringValue,
        selectedMonitoring,
        togglestateMonitoring
      } = this.props;

      let SelectedValue = e.target.value;
      this.setState({ selectedMonitoringvalue: e.target.value });

      const matchingState = monitoringOptions.find(function(state) {
        return state.value == SelectedValue;
      });
      const selectedLabel = matchingState ? matchingState.label : undefined;
      let selectedValue = {
        name: selectedLabel ? selectedLabel : "",
        label: selectedLabel ? selectedLabel : "",
        value: SelectedValue ? SelectedValue : "",
        optionName: "Monitoring"
      };

      let selectedState1;
      if (
        JSON.parse(localStorage.getItem("selectedState")) == null ||
        JSON.parse(localStorage.getItem("selectedState")) == undefined
      ) {
        selectedState1 = {
          name: "",
          label: "Select State/ut",
          value: "",
          optionName: "Select State/ut"
        };
      } else {
        selectedState1 = JSON.parse(localStorage.getItem("selectedState"));
      }
      if (selectedValue !== null) {
        const updatedArray = [];
        if (
          selectedValue.value !== null &&
          selectedValue.value !== "" &&
          selectedValue.value !== undefined
        )
          updatedArray.push(selectedValue);
        if (
          selectedState1.value !== null &&
          selectedState1.value !== "" &&
          selectedState1.value !== undefined
        ) {
          updatedArray.push(selectedState1);
        }

        localStorage.setItem("filtersList", JSON.stringify(updatedArray));
      }

      //fetchMonitoringValue(selectedValue)
      localStorage.setItem("monitoring", JSON.stringify(selectedValue));

      fetch(fetchStateProjectReport2(selectedState, selectedValue, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {
          // Handle errors
        });
      //updateSelectedItems()
    };

    let selectedMonitoring2;
    if (
      selectedMonitoring.value == null ||
      selectedMonitoring.value == undefined
    ) {
      selectedMonitoring2 = {
        name: "",
        label: "Select Monitoring Flag",
        value: " ",
        optionName: "Select Monitoring FlaG"
      };
    } else {
      selectedMonitoring2 = JSON.parse(localStorage.getItem("monitoring"));
    }

    let clearStatevariable;
    if (selectedState.value == null || selectedState.value == undefined) {
      clearStatevariable = {
        name: "",
        label: "Select State/UT",
        value: "123",
        optionName: "Select State/UT"
      };
    } else {
      clearStatevariable = {
        name: selectedState.name,
        label: selectedState.label,
        value: selectedState.value,
        optionName: selectedState.name
      };
    }

    let selectedMeetingType1;
    if (selectMeetingType == null || selectMeetingType == undefined) {
      selectedMeetingType1 = {
        name: "",
        label: "Selectttttt Meeting Type",
        value: "",
        optionName: "Select Meeting Type"
      };
    } else {
      selectedMeetingType1 = {
        name: selectMeetingType.name,
        label: selectMeetingType.label,
        value: selectMeetingType.value,
        optionName: selectMeetingType.name
      };
    }
    var dropdownOptions = stateOptions
      ? stateOptions.map(function(state) {
          return {
            value: state.value,
            label:
              state.label.length >= 20
                ? state.label.substring(0, 20) + "..."
                : state.label
          };
        })
      : [];
    var monitoringDropdownOptions = monitoringOptions
      ? monitoringOptions.map(function(state) {
          return {
            value: state.value,
            label: state.label
          };
        })
      : [];
    var meetingDropdownOptions = meetingOptions
      ? meetingOptions.map(function(state) {
          return {
            value: state.value,
            label: state.label
          };
        })
      : [];
    return (
      <>
        <div className="state-summary-filter">
          <div className="input-fields d-flex mt-3">
            <div className="input-field-left select-field dropdown-wrapper">
              {this.state.selectedStatevalue && (
                <label className="floating-label">Select State/UT</label>
              )}
              {/* <CustomDropdown
                options={[
                  { value: "", label: "Select State/UT" },
                  ...dropdownOptions
                ]}
                // value={this.state.selectedStatevalue}
                value={dropdownOptions.find(
                  o => o.value === this.state.selectedStatevalue
                )}
                onChange={(value, name) =>
                  onSourceAutoSuggestChange({
                    target: { value }
                  })
                }
                width="100%"
                height="43px"
                className="custom-floating-dropdown"
                // className={"select-summary-state-dropdown"}
                page="select-summary-state"
                menuClassName="selectStateMenu"
              /> */}
              <select
                class="form-select"
                aria-label="Default select example"
                className={
                  this.state.selectedStatevalue
                    ? "select-state-input1"
                    : "select-state-input "
                }
                value={this.state.selectedStatevalue}
                onChange={e => {
                  onSourceAutoSuggestChange(e);
                }}
              >
                <option value="" selected>
                  Select State/UT
                </option>
                {stateOptions &&
                  stateOptions.map(state => {
                    let stateLabel = state.label;
                    if (state.label.length >= 20) {
                      stateLabel = stateLabel.substring(0, 20) + "...";
                    }

                    return (
                      <option
                        className="select-state-option"
                        value={state.value}
                      >
                        {state.label}&nbsp;&nbsp;&nbsp;
                      </option>
                    );
                  })}
              </select>
            </div>
            {activeReport === "STATE_SUMMARY" ? (
              <div className="input-field-left select-field dropdown-wrapper">
                {this.state.selectedMonitoringvalue && (
                  <label className="floating-label">
                    Select Monitoring Flag
                  </label>
                )}
                {/* <CustomDropdown
                  options={monitoringDropdownOptions}
                  value={monitoringDropdownOptions.find(
                    o => o.value === this.state.selectedMonitoringvalue
                  )}
                  onChange={value =>
                    onSelectofMonitoring({
                      target: { value }
                    })
                  }
                  width="100%"
                  height="43px"
                  className="custom-floating-dropdown"
                  page="select-monitering-state"
                  menuClassName="selectMonitoringMenu"
                /> */}
                <select
                  class="form-select"
                  aria-label="Default select example"
                  className={
                    this.state.selectedMonitoringvalue
                      ? "select-state-input1"
                      : "select-state-input "
                  }
                  value={this.state.selectedMonitoringvalue}
                  onChange={e => {
                    onSelectofMonitoring(e);
                  }}
                >
                  {monitoringOptions &&
                    monitoringOptions.map(state => {
                      return (
                        <option
                          value={state.value}
                          className="select-state-option"
                        >
                          {state.label}
                        </option>
                      );
                    })}
                </select>
              </div>
            ) : (
              <div className="input-field-left select-field dropdown-wrapper">
                {this.state.selectedMeetingvalue && (
                  <label className="floating-label">Select Meeting Type</label>
                )}
                {/* <CustomDropdown
                  options={[
                    { value: "", label: "Select Meeting Type" },
                    ...meetingDropdownOptions
                  ]}
                  value={this.state.selectedMeetingvalue}
                  onChange={value =>
                    onSelectMeetingType({
                      target: { value }
                    })
                  }
                  width="100%"
                  height="43px"
                  className="custom-floating-dropdown"
                  page="select-meeting-type"
                  menuClassName="selectMeetingMenu"
                /> */}
                <select
                  class="form-select"
                  aria-label="Default select example"
                  className={
                    this.state.selectedMeetingvalue
                      ? "select-state-input1"
                      : "select-state-input "
                  }
                  value={this.state.selectedMeetingvalue}
                  onChange={e => {
                    onSelectMeetingType(e);
                  }}
                >
                  <option value="" selected>
                    Select Meeting Type
                  </option>
                  {meetingOptions &&
                    meetingOptions.map(state => {
                      return (
                        <option
                          value={state.value}
                          className="select-state-option"
                        >
                          {state.label}
                        </option>
                      );
                    })}
                </select>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    sectorsList: state.misReducer.sectorsList,
    implementationModesList: state.misReducer.implementationModesList,
    statesListData: state.misReducer.statesList,
    schemesList: state.misReducer.schemesList,
    projectStatusList: state.misReducer.projectStatusList,
    ddByParentIdsList: state.misReducer.ddByParentIdsList,
    activeReport: state.misReducer.activeReport,
    selectedState: state.misReducer.selectedState,
    selectedMonitoring: state.misReducer.selectedMonitoring,
    agendaList: state.misReducer.agendaList,
    issueList: state.misReducer.issueList,
    selectMeetingType: state.misReducer.selectMeetingType
    //togglestateMonitoring:state.misReducer.togglestateMonitoring
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAllStatesAction,
      getMeetingTypesDetails,
      getMisListAction,
      fetchProjectReport,
      fetchIssueSubCategories,
      fetchStateProjectReport2,
      fetchSelectedStateValue,
      fetchSelectedMonitoringValue,
      fetchMonitoringValue,
      getAllMoms,
      fetchMeetingValue,
      getIssueList,
      getIssuesTimelineLapsed,
      getIssuesPending,
      getIssuesResolved,
      getIssuesReviewed,
      getmeetingsCount,
      getmeetingsDateAction,
      getmeetingsCount
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(StateSummaryFilter)
);
